import React from 'react';
import { createRoot } from 'react-dom/client';
import 'styles/fonts.css';
import '@yabble/yabble-component-library/styles/ycl.css';
import { SnackbarService } from '@yabble/yabble-component-library/services';
import { YabbleComponentLibraryBaseStyle } from '@yabble/yabble-component-library/styles';
import { BaseStyle } from 'styles/base.style';
import App from './App';

const target = document.getElementById('root');

if (!target) {
  throw new Error('Cannot mount ai-compliance-ui: #root is missing from index.html');
}

/**
 * The mock backend has to be intercepting before the first request goes out, so it is
 * awaited ahead of the render rather than started alongside it. The import is dynamic so
 * neither MSW nor the fixtures end up in a build with mocks switched off.
 */
const startMocks = async () => {
  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') return;
  const { startMocks: start } = await import('mocks/browser');
  await start();
};

/**
 * The back/forward cache restores a page with its JS state as it was frozen — after a
 * sign-out, possibly the authenticated app. Reloading runs the session restore again
 * instead, which finds no session and lands on the login page.
 */
window.addEventListener('pageshow', (event) => {
  if (event.persisted) window.location.reload();
});

startMocks().then(() =>
  createRoot(target).render(
    <React.StrictMode>
      <YabbleComponentLibraryBaseStyle />
      <BaseStyle />
      {/* Mounted once, at the root: `services/api` raises every request failure here. */}
      <SnackbarService />
      <App />
    </React.StrictMode>
  )
);
